import React, { ComponentPropsWithoutRef, FC } from "react";
import cn from "classnames";
import { ReactComponent as CheckIcon } from "src/assets/icons/check.svg";

interface Props extends ComponentPropsWithoutRef<"input"> {}

export const Checkbox: FC<Props> = ({ className, checked, type, ...props }) => (
  <label
    className={cn(
      "flex items-center justify-center w-6 h-6 border border-green-base rounded-1 cursor-pointer",
      { "bg-green-base": checked },
      className
    )}
  >
    {checked && <CheckIcon className="w-3.5 h-3.5 fill-blue-base" />}
    <input className="hidden" type="checkbox" {...props} />
  </label>
);
